// FR-011: exact copyright notice shown at the bottom of every page.
export function Footer() {
  return (
    <div className="border-t border-line bg-white" data-testid="app-footer" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <p className="max-w-7xl mx-auto px-5 py-4 text-xs text-muted2 text-center leading-relaxed" data-testid="copyright">
        © 2026 <a href="https://www.linkedin.com/in/tapiwa-mapunde-b72655423" target="_blank" rel="noopener noreferrer" data-testid="author-linkedin-link" className="font-bold text-clinical hover:underline">Tapiwa Marvin Mapunde</a>. All Rights Reserved.<br />
        Authored and designed by Tapiwa Marvin Mapunde - Master of Science in Global Healthcare Leadership.
      </p>
    </div>
  );
}
